module.exports = __webpack_public_path__ + "static/media/needs_attention.d8769a02.svg";